// extracted by mini-css-extract-plugin
module.exports = {"caption":"OfficesTableExplain_caption__97lwx"};